import React, { useState, useRef, Fragment, useEffect } from "react";
import { history } from "../../helpers/history";
import cardHolderService from "../../services/cardholder.service";
import DateFormat from "../../helpers/DateFormat";
import crossImgs from "../../assets/images/icons/cross.svg";
import RefreshToken from "../../helpers/RefreshToken";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import ExportToExcel from "../superadmin/ExportToExcel";
import DialoguePopup from "../../helpers/DialoguePopup";
import ModelPopup from "../../helpers/ModelPopup";
import BoLoader from "../../helpers/BoLoader";
import GetAllClients from "../../helpers/GetAllClients";

const SearchGridInputData = [
  {
    TokenId: "",
    DateFrom: "",
    DateTo: "",
    Amount: "",
    CardHolderName: "",
    ClientId: "",
    PageSize: 20,
    StartIndex: 1,
    PageNo: 1,
    FetchAll: false,
    scrolled: false,
  },
];

var fontStyle = {
  textTransform: "uppercase",
};

const NegativeBalanceGrid = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [name, setCompanyName] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [Amount, setAmount] = useState("");
  const searchTbl = useRef();
  const [loadingData, setLoadingData] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [searchGridSuccess, setSearchGridSuccess] = useState(false);
  const [SearchInputDisabled, setSearchDisabled] = useState(false);
  const [clientIdVal, setClientIdVal] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [classContent, setClassContent] = useState("tab-content");

  //Dialouge Popup Error Messages
  const [modalShowDialouge, setModalShowDialouge] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [modelbdy, setMdlBdy] = useState("");

  const [boloader, setBoLoader] = useState(false);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  // ✅ Export states (same pattern as Running Balance)
  const [dataset, setDataset] = useState([]);
  const [isExcelDownload, setiisExcelDownload] = useState(false);
  const [showExcelDownloadModal, setshowExcelDownloadModal] = useState(false);
  const [isOldData, setIsOldData] = useState(false); // UI-only (kept for same UX)

  // ✅ Export modal only client selection
  const [exportClientIdVal, setExportClientIdVal] = useState("");

  const errorAndSuccessModl = (heading, body, Icon) => {
    setModalShowDialouge(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(Icon);
  };

  useEffect(() => {
    SearchClickHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputSearchClick = (e) => {
    e.preventDefault();
    setModalShow(true);
    setSearchDisabled(true);
  };

  const nameChangeHandler = (e) => {
    SearchGridInputData[0].CardHolderName = e.target.value;
    setCompanyName(e.target.value);
  };

  const onChangeTokenId = (e) => {
    SearchGridInputData[0].TokenId = e.target.value;
    setTokenId(e.target.value);
  };

  const onChangeAmount = (e) => {
    SearchGridInputData[0].Amount = e.target.value;
    setAmount(e.target.value);
  };

  const dateFilter = (date) => new Date(date);

  const dateFromHandler = (e) => {
    SearchGridInputData[0].DateFrom = e;
    if (e) SearchGridInputData[0].DateFrom = dateFilter(e);
    setDateFrom(SearchGridInputData[0].DateFrom);
  };

  const dateToHandler = (e) => {
    SearchGridInputData[0].DateTo = e;
    if (e) SearchGridInputData[0].DateTo = dateFilter(e);
    setDateTo(SearchGridInputData[0].DateTo);
  };

  const ClientNameChangeHandler = (e) => {
    const clientName = e.target.selectedOptions[0].value;
    setClientIdVal(clientName);
  };

  // ✅ Client dropdown handler for Export modal only
  const ExportClientNameChangeHandler = (e) => {
    const clientId = e.target.selectedOptions[0].value;
    setExportClientIdVal(clientId);
  };

  const SearchClickHandler = (e) => {
    setLoadingData(true);

    if (e) {
      e.preventDefault();
      SearchGridInputData[0].PageNo = 1;
      SearchGridInputData[0].StartIndex = 1;
    }

    if (!SearchGridInputData[0].scrolled) {
      setSearchGridSuccess(false);
    }

    setModalShow(false);
    setSearchDisabled(false);

    // ✅ normal listing call => FetchAll false
    SearchGridInputData[0].FetchAll = false;

    cardHolderService
      .getnegativecardbalances(
        (SearchGridInputData[0].TokenId || "").toString(),
        (SearchGridInputData[0].CardHolderName || "").toString(),
        clientIdVal,
        SearchGridInputData[0].PageSize,
        SearchGridInputData[0].StartIndex,
        SearchGridInputData[0].PageNo,
        SearchGridInputData[0].FetchAll,
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        Math.abs(Number(Amount || 0))
      )
      .then((resp) => {
        setLoadingData(false);

        if (resp && resp?.data?.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
          }

          const pageModel = resp?.data?.payload?.pageModel || [];
          if (pageModel.length > 0 || (searchData && searchData.length > 0)) {
            setTotalCount(resp.data.payload?.totalCount || 0);

            const sortedData = pageModel
              .slice()
              .sort((a, b) => (b.declineCount || 0) - (a.declineCount || 0));

            if (SearchGridInputData[0].scrolled) {
              const appendedData = (searchData || []).concat(sortedData);
              setSearchData(appendedData);
            } else {
              setSearchData(sortedData);
              SearchGridInputData[0].PageNo = 1;
              SearchGridInputData[0].StartIndex = 1;
            }

            setSearchGridSuccess(true);
            SearchGridInputData[0].scrolled = false;

            if (searchTbl.current) {
              searchTbl.current.onscroll = tblScrollHandler;
            }
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);

        (async () => {
          const resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
  };

  const tblScrollHandler = () => {
    if (
      !SearchGridInputData[0].scrolled &&
      SearchGridInputData[0].StartIndex + 20 <= totalCount
    ) {
      SearchGridInputData[0].scrolled = true;
      SearchGridInputData[0].StartIndex = SearchGridInputData[0].StartIndex + 20;
      SearchGridInputData[0].PageNo = SearchGridInputData[0].PageNo + 1;
      SearchClickHandler();
    }
  };

  const renderTableHeader = () => {
    let header = Object.values(props.headersdata);
    return header.map((key, index) => <th key={index}>{key.toUpperCase()}</th>);
  };

  const showCardHolderDetailPage = (id, userId, issuerCategory) => {
    history.push("/cardholderdetails", { id, userId, issuerCategory });
  };

  const renderTableData = () => {
    return (searchData || []).map((data, index) => {
      const {
        tokenId,
        clientName,
        createdAt,
        userId,
        cardholderUUID,
        issuerCategory,
        name,
        balance,
      } = data;

      return (
        <tr key={index}>
          <td style={fontStyle}>{clientName}</td>
          <td>
            <span
              style={{ color: "#0d6efd", cursor: "pointer" }}
              title="View Card Holder Details"
              onClick={() =>
                showCardHolderDetailPage(cardholderUUID, userId, issuerCategory)
              }
            >
              {tokenId}
            </span>
          </td>
          <td style={fontStyle}>{name}</td>
          <td style={fontStyle}>{balance}</td>
          <td>
            <DateFormat date={createdAt} />
          </td>
        </tr>
      );
    });
  };

  const HideSearchPopupDiv = () => {
    setModalShow(false);
    setSearchDisabled(false);
  };

  const ClearSearchData = () => {
    SearchGridInputData[0].TokenId = "";
    SearchGridInputData[0].Amount = "";
    SearchGridInputData[0].DateFrom = "";
    SearchGridInputData[0].DateTo = "";
    SearchGridInputData[0].CardHolderName = "";
    SearchGridInputData[0].ClientId = "";
    SearchGridInputData[0].PageSize = 20;
    SearchGridInputData[0].StartIndex = 1;
    SearchGridInputData[0].PageNo = 1;
    SearchGridInputData[0].FetchAll = false;

    setTokenId("");
    setDateFrom("");
    setDateTo("");
    setAmount("");
    setCompanyName("");
    setClientIdVal("");

    ClearInputData();
  };

  const ClearInputData = () => {
    if (document.getElementById("clientNameDD") !== null)
      document.getElementById("clientNameDD").value = "";

    setClientIdVal("");

    setTimeout(() => {
      [...document.getElementsByClassName("r-input-group")].forEach((element) => {
        element.children[0].value = "";
      });
      const btn = document.getElementById("searchBtnClients");
      if (btn) btn.click();
    }, 500);
  };

  // ✅ Export actions (same UX as Running Balance)
  const showExcelModel = () => {
    setIsOldData(false);
    setExportClientIdVal(""); // ✅ reset export modal client
    setshowExcelDownloadModal(true);
  };

  const handleSingleCheck = (e) => {
    setIsOldData(e.target.checked === true);
  };

  const downloadExportToExcel = () => {
    setBoLoader(true);

    // Fetch all for export
    cardHolderService
      .getnegativecardbalances(
        (SearchGridInputData[0].TokenId || "").toString(),
        (SearchGridInputData[0].CardHolderName || "").toString(),
        exportClientIdVal || clientIdVal, // ✅ export modal client selection
        SearchGridInputData[0].PageSize,
        1,
        1,
        true, // ✅ FetchAll true for export
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        Math.abs(Number(Amount || 0))
      )
      .then((resp) => {
        const pageModel = resp?.data?.payload?.pageModel || [];

        const sortedData = pageModel
          .slice()
          .sort((a, b) => (b.declineCount || 0) - (a.declineCount || 0));

        setDataset(sortedData);
        setshowExcelDownloadModal(false);
        setiisExcelDownload(true);

        // optional reset filters like RunningBalance
        setDateFrom("");
        setDateTo("");

        setBoLoader(false);
      })
      .catch((error) => {
        setBoLoader(false);
        setshowExcelDownloadModal(false);

        (async () => {
          const resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            downloadExportToExcel();
          }
        })();
      });
  };

  const resetModal = () => {
    setIsOldData(false);
    setiisExcelDownload(false);
    setDataset([]);
    setExportClientIdVal(""); // ✅ reset export modal client
    dateToHandler("");
    dateFromHandler("");
  };

  return (
    <div className="mt-0 mt-sm-4">
      <div className={classContent} id="myTabContent2">
        <BoLoader loading={boloader} />

        {/* ✅ Export UI row (same place/pattern as Running Balance) */}
        <div className="row">
          <div className="col-sm-2 toRight ms-auto mt-sm-100 mt-4 mb-4">
            {isExcelDownload ? (
              <Fragment>
                <div>
                  <ExportToExcel
                    Dataset={dataset}
                    calledfrom="negativebalance"
                    Name={"NegativeBalance"}
                  />
                  <button
                    id="searchBtnExportToExcel"
                    className="btn btn-large mt-3"
                    onClick={resetModal}
                  >
                    Reset
                  </button>
                </div>
              </Fragment>
            ) : (
              <button
                id="searchBtnExportToExcel"
                className="btn btn-large mr-19"
                onClick={showExcelModel}
              >
                Export
              </button>
            )}
          </div>
        </div>

        <div
          className="tab-pane fade show active"
          id="allClients"
          role="tabpanel"
          aria-labelledby="allClients-tab"
        >
          <Fragment>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row row-search">
                <div className="col-xl-12 col-12">
                  <div className="form-group">
                    <div className="form-controls">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.placeholdervalue}
                        onClick={handleInputSearchClick}
                        disabled={SearchInputDisabled}
                      />
                      <span className="icon-search _ico"></span>

                      <div
                        className="bo-cardsearch"
                        style={{ display: modalShow ? "" : "none" }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="col-md-4">
                              <img
                                className="cross-icon cross-modal"
                                src={crossImgs}
                                aria-label="Close"
                                onClick={HideSearchPopupDiv}
                                alt=""
                              />
                            </div>
                            <div className=" col-md-12 form-group form-search mr-20">
                              <label>Name</label>
                              <div className="form-controls mr-20">
                                <input
                                  type="text"
                                  value={name}
                                  onChange={nameChangeHandler}
                                  className="form-control"
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>

                          <div className=" col-md-6 form-group form-search">
                            <label>Amount</label>
                            <div className="form-controls mr-20">
                              <input
                                type="text"
                                value={Amount}
                                onChange={onChangeAmount}
                                className="form-control"
                                maxLength={20}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label>Date From</label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dateFrom}
                                  onchangedate={dateFromHandler}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label>Date To</label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dateTo}
                                  onchangedate={dateToHandler}
                                />
                              </div>
                            </div>
                          </div>

                          <div className=" col-md-6 form-group form-search">
                            <label>Token Id</label>
                            <div className="form-controls mr-20">
                              <input
                                type="text"
                                value={tokenId}
                                onChange={onChangeTokenId}
                                className="form-control"
                                maxLength={20}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label className="mb-24">Client Name</label>
                              <div className="form-controls">
                                <GetAllClients
                                  clientnamechangehandler={ClientNameChangeHandler}
                                  searchgriddata={"Y"}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group submit-field form-search">
                              <button
                                id="searchBtnClients"
                                className="btn btn-large mr-19"
                                onClick={SearchClickHandler}
                              >
                                Search
                              </button>
                              <button
                                className="btn btn-outline"
                                onClick={ClearSearchData}
                              >
                                Clear Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <span className="help-block d-none"></span>
                  </div>
                </div>
              </div>
            </form>
          </Fragment>
        </div>

        {searchGridSuccess && (
          <div className="table-wrap" ref={searchTbl}>
            <table
              className="table table-borderless bo-table table-cards"
              onScroll={tblScrollHandler}
              onWheel={tblScrollHandler}
            >
              <thead>
                <tr>{renderTableHeader()}</tr>
              </thead>
              <tbody>{renderTableData()}</tbody>
            </table>
          </div>
        )}

        {loadingData ? (
          <div className="loading-more">
            <div className="loader">
              <div></div>
            </div>
            <p>loading data</p>
          </div>
        ) : totalCount === 0 ? (
          <div className="d-flex align-content-center justify-content-center  no-clients-msg">
            <div className="text-center">
              <span className="icon-clients-empty">
                <span className="path1"></span><span className="path2"></span>
                <span className="path3"></span><span className="path4"></span>
                <span className="path5"></span><span className="path6"></span>
              </span>
              <h3>Empty Transaction Listing</h3>
              <h6>There is no Transaction(s) available for now.</h6>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <DialoguePopup
        show={modalShowDialouge}
        onHide={() => setModalShowDialouge(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />

      {/* ✅ Export modal (same UX as Running Balance) */}
      <ModelPopup
        show={showExcelDownloadModal}
        onHide={() => setshowExcelDownloadModal(false)}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-52"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <BoLoader loading={boloader} />
            <div className="row">
              <div className="col-md-12">
                <h2>Export To Excel</h2>
                <div className="mt-16">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group form-search mr-20">
                          <label>Date From</label>
                          <div className="form-controls">
                            <ReactDatePickerHelper
                              datevalue={dateFrom}
                              onchangedate={dateFromHandler}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group form-search mr-20">
                          <label>Date To</label>
                          <div className="form-controls">
                            <ReactDatePickerHelper
                              datevalue={dateTo}
                              onchangedate={dateToHandler}
                            />
                          </div>
                        </div>
                      </div>

                      {/* ✅ Client Name ONLY in export modal */}
                      <div className="col-md-6">
                        <div className="form-group form-search mr-20">
                          <label className="mb-24">Client Name</label>
                          <div className="form-controls">
                            <GetAllClients
                              clientnamechangehandler={ExportClientNameChangeHandler}
                              searchgriddata={"Y"}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 form-checkbox mb-16 mt-16">
                        <input
                          type="checkbox"
                          name="olderdatachks"
                          id="olderdatachks"
                          onClick={(e) => handleSingleCheck(e)}
                        />
                        <label className="checkbox-label" htmlFor="olderdatachks">
                          More Than 3 Months
                        </label>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group submit-field d-flex justify-content-between mt-20 mb-0">
                          <button
                            className="btn btn-large"
                            onClick={downloadExportToExcel}
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
    </div>
  );
};

export default NegativeBalanceGrid;
